module.exports = __webpack_public_path__ + "img/slolution-8.a2aa5d5.png";